(function() {
  'use strict';
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;
  var section = document.querySelector('.shop-by-product');
  if (!section) return;

  var ALLOWED_BADGES = ['just-dropped','limited','crazy','bestseller','new','coming-soon'];

  // Embedded fallback drops with badges. Used immediately so the new layout ships
  // without waiting on /pages/drop-blocks-config (which Shopify caches aggressively).
  // The config page is still fetched and overrides this once it propagates.
  var EMBEDDED_DROPS = [{"name": "Irises", "handle": "irises", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/36_Irises_Main.png?v=1777517918", "badge_style": "just-dropped", "badge_text": "Just Dropped", "cta": "Shop"}, {"name": "Aura Farming", "handle": "aura-farming", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/36_AuraFarming_Main.png?v=1776913387", "badge_style": "just-dropped", "badge_text": "Just Dropped", "cta": "Shop"}, {"name": "Glowie Turtle", "handle": "glowie-turtle", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/4_9db299ac-15ed-4904-a6f6-1f16c5aa2c9c.png?v=1775703946", "badge_style": "crazy", "badge_text": "Crazy Release", "cta": "Shop"}, {"name": "Bouquet of Sunflowers", "handle": "bouquet-of-sunflowers", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_BouquetSunFlower_Main.png?v=1776310696", "badge_style": "limited", "badge_text": "Limited Remaining", "cta": "Shop"}, {"name": "Blue Opal", "handle": "blue-opal", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/20oz_BlueOpal_Main.png?v=1775101235", "badge_style": "bestseller", "badge_text": "Bestseller", "cta": "Shop"}, {"name": "The World Stage", "handle": "the-world-stage", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/36_TheWorldStage_Main.png?v=1775216289", "badge_style": "new", "badge_text": "New", "cta": "Shop"}, {"name": "Mont Sainte", "handle": "mont-sainte", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/36_MontSainte_Main.png?v=1775216289", "badge_style": "limited", "badge_text": "Limited Remaining", "cta": "Shop"}, {"name": "Flirt & Flower", "handle": "flirt-flower", "image": "//cdn.shopify.com/s/files/1/0667/5650/9928/files/36_FlirtFlower_Main.png?v=1775216289", "badge_style": "limited", "badge_text": "Limited Remaining", "cta": "Shop"}];

  function withWidth(u, w) {
    if (!u) return '';
    var clean = String(u).replace(/[?&]width=\d+/, '');
    var sep = clean.indexOf('?') > -1 ? '&' : '?';
    return clean + sep + 'width=' + w;
  }
  function buildSrcset(src) {
    if (!src) return '';
    return withWidth(src, 400) + ' 400w, ' + withWidth(src, 800) + ' 800w, ' + withWidth(src, 1200) + ' 1200w';
  }
  function safe(s) { return (s == null ? '' : String(s)); }

  function buildItem(drop) {
    var item = document.createElement('div');
    item.className = 'product-item';
    var link = document.createElement('a');
    link.href = drop.handle ? '/collections/' + drop.handle : (drop.filter_url || drop.url || '#');
    link.setAttribute('aria-label', 'Shop ' + safe(drop.name));

    if (drop.badge_style && drop.badge_text && ALLOWED_BADGES.indexOf(drop.badge_style) !== -1) {
      var badge = document.createElement('span');
      badge.className = 'sbp-badge sbp-badge--' + drop.badge_style;
      badge.textContent = drop.badge_text;
      link.appendChild(badge);
    }

    var img = document.createElement('img');
    img.src = drop.image;
    var ss = buildSrcset(drop.image);
    if (ss) img.srcset = ss;
    img.sizes = '(min-width: 1100px) 25vw, (min-width: 600px) 25vw, 50vw';
    img.alt = safe(drop.name);
    img.loading = 'lazy';
    img.decoding = 'async';

    var titleWrap = document.createElement('div');
    titleWrap.className = 'sbp-title';
    var nameSpan = document.createElement('span');
    nameSpan.className = 'sbp-title__name';
    nameSpan.textContent = safe(drop.name);
    titleWrap.appendChild(nameSpan);
    if (drop.cta) {
      var ctaSpan = document.createElement('span');
      ctaSpan.className = 'sbp-title__cta';
      ctaSpan.textContent = drop.cta;
      titleWrap.appendChild(ctaSpan);
    }

    link.appendChild(img);
    link.appendChild(titleWrap);
    item.appendChild(link);
    return item;
  }

  function render(drops) {
    var grid = section.querySelector('.product-grid');
    if (!grid) return;
    var frag = document.createDocumentFragment();
    drops.forEach(function(d) { frag.appendChild(buildItem(d)); });
    grid.innerHTML = '';
    grid.appendChild(frag);
  }

  // 1. Render embedded drops immediately (so layout + badges always ship)
  try { render(EMBEDDED_DROPS); } catch(e) { console.warn('[Coldest Drops] embed render failed', e); }

  // 2. Try to overlay with live config (cache may serve stale; that's fine — fallback already shown)
  fetch('/pages/drop-blocks-config', { credentials: 'omit' })
    .then(function(res) { return res.text(); })
    .then(function(html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var script = doc.querySelector('#drop-blocks-data');
      if (!script) return;
      var drops;
      try { drops = JSON.parse(script.textContent); } catch(e) { return; }
      if (!drops || !drops.length) return;
      // Only re-render if config has badge metadata (otherwise embedded version is richer)
      if (drops.some(function(d) { return d.badge_style; })) {
        render(drops);
      }
    })
    .catch(function(err) { console.warn('[Coldest Drops] config fetch failed:', err); });
})();
